module.exports = __webpack_public_path__ + "img/cat-03-ac.3d0c2cd7.svg";